<header class="banner-section d-flex justify-content-center align-items-center">
  <div class="header-content container">
    <div class="container-workspace">
      <h1 [title]="translation?.homePageTitle" class="e-service-title">{{translation?.homePageTitle || 'E-services Platform'}}</h1>
      <p [title]="translation?.homePageSubTitle" class="e-service-brief">{{translation?.homePageSubTitle || 'The quickest way to Apply for Services while sitting at Home'}}</p>
      <!-- <a  aria-label="go To WorkSpace" [title]="translation?.goToWorkSpace || 'Go toWorkspace'" [routerLink]="workspaceLink" class="btn btn-primary service-link">
        {{translation?.workSpace || 'Workspace'}}
      </a> -->
  </div>
    <div class="night">
      <ng-container *ngFor="let star of shootingStarsArray;trackBy: trackByIndex">
        <div class="shooting_star"></div>
      </ng-container>
    </div>
    <div class="night2">
      <ng-container *ngFor="let star of shootingStarsArray2;trackBy: trackByIndex">
        <div class="shooting_star"></div>
      </ng-container>
    </div>

  </div>
</header>
<div *ngIf="showServiceCatalog">
  <service-list [pageSize]="6" 
                [isHomepage]="true"   
                (componentLoaded)="serviceCatalogComponentLoaded($event)"
                loadingStrategy="lazy"></service-list>
</div>
<router-outlet></router-outlet>
